const meeting_minute = {
  permissionSource: 'api::meeting-minute.meeting-minute',
  creationTitle: 'Create Meeting Minute',
  creationEndPoint: '/meeting-minutes',
  detailTitle: 'Meeting Minute: :code',
  detailEndPoint: '/meeting-minutes/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Title',
          value: 'title',
          tag: 'input',
          type: 'text',
          placeholder: 'Meeting Minute Title',
          required: true,
        },
        {
          label: 'Default',
          value: 'default',
          tag: 'switch',
        },
      ],
    },
    {
      label: 'Meeting',
      value: 'meeting',
      tag: 'single-select',
      dataSourceUrl: '/meetings',
      dataLabel: 'title',
      required: true,
    },
    {
      label: 'Description',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'Meeting Minute Description',
    },
  ],
}
export default meeting_minute
